module.exports = __webpack_public_path__ + "static/media/hair-1.def19ff2.svg";